import { put, takeEvery } from 'redux-saga/effects'
import { ORDER_MENU_LOADING, ORDER_MENU_SUCCESS, ORDER_MENU_ERROR } from "../actions/actionOrdersMenu";
import { apiGetProductsByProductTypeAndDisplayArea } from 'api'

async function fetchAsync(func, param1, param2) {
    const response = await func(param1, param2);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get Order Menu, response status: " + response.status + "\"}]}")
    }
}

function* fetchOrderMenuByDisplayArea(action) {
    try {
        const data = yield fetchAsync(apiGetProductsByProductTypeAndDisplayArea, "foodmenusimple", action.payload);
        if (data == "nocontent") throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"No Order Menu were found.\"}]}")
        else {
            yield put({ type: ORDER_MENU_SUCCESS, payload: data });
        }
    } catch (e) {
        yield put({ type: ORDER_MENU_ERROR, error: e });
    }
}

export const sagaOrderMenu = [
    takeEvery(ORDER_MENU_LOADING, fetchOrderMenuByDisplayArea)
];
